const InterfaceTypes = {
    TextFile: 'TextFile',
    BinaryFile: 'BinaryFile',
    TextStream: 'TextStream',
    BinaryStream: 'BinaryStream',
    Image: 'Image',
    Mesh: 'Mesh',
    PolyData: 'PolyData',
    JsonCompatible: 'JsonCompatible'
};
export default InterfaceTypes;
//# sourceMappingURL=interface-types.js.map